import { layerlist } from './maplayers';

/*
 * Remembers which layer (State, Province, Culture...) was chosen on each map
 * for the rest of the browser session, so leaving the map (e.g. Create new
 * content -> Back) brings you back to the same layer instead of State.
 * Used by the three world-map screens (game, player, Maps viewer).
 */
const DEFAULT_LAYER = 'state';
const key = (mapId: string | null) => `wt-map-layer:${mapId ?? ''}`;

export function rememberMapLayer(mapId: string | null, layerName: string): void {
  try {
    sessionStorage.setItem(key(mapId), layerName);
  } catch {
    /* storage unavailable: the map simply opens on State */
  }
}

/**
 * Sets the shared layer list to the remembered layer (or State) and returns
 * its name. `checked` drives the layer buttons; `visible` is what the map
 * uses when it creates its layers.
 */
export function applyRememberedMapLayer(mapId: string | null): string {
  let chosen = DEFAULT_LAYER;
  try {
    const saved = sessionStorage.getItem(key(mapId));
    if (saved && layerlist.some((l) => l.toggle && l.name === saved && l.name !== 'zones')) {
      chosen = saved;
    }
  } catch {
    /* storage unavailable */
  }

  layerlist.forEach((layer) => {
    layer.checked = layer.name === chosen;
    if (layer.toggle && layer.name !== 'zones') {
      layer.visible = layer.name === chosen;
    }
  });
  return chosen;
}
